import { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useTranslation } from 'react-i18next';
import { ToastContainer } from 'react-toastify';
import { SettingsProvider } from '@/contexts/SettingsContext';
import routes from './routes';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const { i18n } = useTranslation();
  const routing = useRoutes(routes);

  // Set dayjs locale based on current language
  useEffect(() => {
    const lang = i18n.language || 'en';
    if (lang === 'zh') {
      import('dayjs/locale/zh-cn').then(() => dayjs.locale('zh-cn'));
    } else if (lang === 'de') {
      import('dayjs/locale/de').then(() => dayjs.locale('de'));
    } else {
      import('dayjs/locale/en').then(() => dayjs.locale('en'));
    }
  }, [i18n.language]);

  const adapterLocale = i18n.language === 'zh' ? 'zh-cn' : i18n.language === 'de' ? 'de' : 'en';

  return (
    <SettingsProvider>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={adapterLocale}>
        {routing}
      </LocalizationProvider>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </SettingsProvider>
  );
}

export default App;
